import { getCache } from "../../util/Cache";

export const fetchGetPhotoMeterAll = async () => {
    let key = process.env.REACT_APP_API_KEY || '';
    var myHeaders = new Headers();
    myHeaders.append("Authorization", key); 
    const url = process.env.REACT_APP_API_URL + "/hublang/koreksi-meter/photo-meter";    
    try {
        const response = await fetch(url,{
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        })

        const result = await response.json();
        return { status: result.status, data: result.data };

    } catch (error) {
        console.error('Error:', error);
        return { status: 500, message: "Terjadi kesalahan pada server", data: [] };
    }
};

export const fetchGetPhotoMeterTagihanAll = async (nsb : string) => {
    if(nsb === '') return;
    let key = process.env.REACT_APP_API_KEY || '';
    var myHeaders = new Headers();
    myHeaders.append("Authorization", key);
    const url = process.env.REACT_APP_API_URL + "/hublang/koreksi-meter/tagihan-photo-meter/" + nsb;
    try {
        const response = await fetch(url,{
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        })

        const result = await response.json();
        return { status: result.status, data: result.data };

    } catch (error) {
        console.error('Error:', error);
        return { status: 500, message: "Terjadi kesalahan pada server", data: [] };
    }
};

export const fetchGetKoreksiMeterPelangganAll = async () => {
  let key = process.env.REACT_APP_API_KEY || '';
  var myHeaders = new Headers();
  myHeaders.append("Authorization", key); 
  const url = process.env.REACT_APP_API_URL + "/hublang/koreksi-meter/pelanggan";    
  try {
      const response = await fetch(url,{
          method: 'GET',
          headers: myHeaders,
          redirect: 'follow'
      })

      const result = await response.json();
      return { status: result.status, data: result.data };

  } catch (error) {
      console.error('Error:', error);
      return { status: 500, message: "Terjadi kesalahan pada server", data: [] };
  }
};

export const fetchGetKoreksiMeterPelanggan = async (nsb : string) => {
  if(nsb === '') return;
  let key = process.env.REACT_APP_API_KEY || '';
  var myHeaders = new Headers();
  myHeaders.append("Authorization", key);
  const url = process.env.REACT_APP_API_URL + "/hublang/koreksi-meter/pelanggan/" + nsb;
  try {
      const response = await fetch(url,{
          method: 'GET',
          headers: myHeaders,
          redirect: 'follow'
      })

      const result = await response.json();
      return { status: result.status, data: result.data };

  } catch (error) {
      console.error('Error:', error);
      return { status: 500, message: "Terjadi kesalahan pada server", data: [] };
  }
};

export const fetchGetKoreksiMeterPetugas = async () => {
  let key = process.env.REACT_APP_API_KEY || '';
  var myHeaders = new Headers();
  myHeaders.append("Authorization", key);
  const url = process.env.REACT_APP_API_URL + "/hublang/koreksi-meter/petugasmeter";
  try {
      const response = await fetch(url,{
          method: 'GET',
          headers: myHeaders,
          redirect: 'follow'
      })

      const result = await response.json();
      return { status: result.status, data: result.data };

  } catch (error) {
      console.error('Error:', error);
      return { status: 500, message: "Terjadi kesalahan pada server", data: [] };
  }
};

export const fetchLppListTanggal = async () => {
    const myHeaders = new Headers();
    let key = process.env.REACT_APP_API_KEY || '';
    myHeaders.append("Authorization", key);
    const url = process.env.REACT_APP_API_URL + "/hublang/lpp/terbentuk";
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        })

        const result = await response.json();
        return { status: result.status, data: result.data }
    } catch (error) {
        console.error('Error :',error);
        return { status: 500, message: "Terjadi kesalahan pada server", data: [] };
    }
}

export const fetchLppListWPetugas = async (petugas : string) => {
    const myHeaders = new Headers();
    let key = process.env.REACT_APP_API_KEY || '';
    myHeaders.append("Authorization", key);
    const url = process.env.REACT_APP_API_URL + "/hublang/lpp/terbentuk/" + petugas;
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        })

        const result = await response.json();
        return { status: result.status, data: result.data }
    } catch (error) {
        console.error('Error :',error);
        return { status: 500, message: "Terjadi kesalahan pada server", data: [] };
    }
}

export const fetchLppListDpha = async (dpha : string) => {
    const myHeaders = new Headers();
    let key = process.env.REACT_APP_API_KEY || '';
    myHeaders.append("Authorization", key);
    const url = process.env.REACT_APP_API_URL + "/hublang/lpp/sapto/dpha/" + dpha;

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        })

        const result = await response.json();
        return { status: result.status, data: result.data }
    } catch (error) {
        console.error('Error :',error);
        return { status: 500, message: "Terjadi kesalahan pada server", data: [] };
    }
}

export const fetchLppRekapDpha = async (dpha : string) => {
    const myHeaders = new Headers();
    let key = process.env.REACT_APP_API_KEY || '';
    myHeaders.append("Authorization", key);
    const url = process.env.REACT_APP_API_URL_V2 + "/hublang/lpp/rekapan/" + dpha;
    try {
        const response = await fetch(url, {
            method : 'GET',
            headers: myHeaders,
            redirect: 'follow'
        })

        const result = await response.json();
        return { status: result.status, data: result.data };
    } catch (error) {
        console.error('Error :', error);
        return { status : 500, message: "Terjadi Kesalahan pada server" }
    }
}

export const fetchPostDataLppDpha = async (data_lpp : any, loket : string, nama_petugas : string, kode_byr : string) => {
    const myHeaders = new Headers();
    let key = process.env.REACT_APP_API_KEY || '';
    myHeaders.append("Authorization", key);

    const formdata = new FormData();
    formdata.append("data_lpp", JSON.stringify(data_lpp));
    formdata.append("loket", loket);
    formdata.append("nama_petugas", nama_petugas);
    formdata.append("kode_byr", kode_byr)
    const url = process.env.REACT_APP_API_URL_V2 + "/hublang/lpp/rekapan";
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: myHeaders,
            body: formdata,
            redirect: 'follow'
        })

        const result = await response.json();
        return { status: result.status, data: result.data }
    } catch (error) {
        console.error('Error :', error);
        return { status : 500, message: "Terjadi Kesalahan pada server" }
    }
}

export const fetchLppListBukaDataGet = async ( tanggal : string, petugas : string ) => {
    const myHeaders = new Headers();
    let key = process.env.REACT_APP_API_KEY || '';
    myHeaders.append("Authorization", key);

    const url = process.env.REACT_APP_API_URL + "/hublang/lpp/terbentuk/data?tanggal="+tanggal+"&petugas="+encodeURIComponent(petugas);
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        })

        const result = await response.json();
        return { status: result.status, data: result.data }
    } catch (error) {
        console.error('Error :',error);
        return { status: 500, message: "Terjadi kesalahan pada server", data: [] };
    }
}

export const fetchLppToday = async (petugas : string, data: any, formatted : string) => {
    const myHeaders = new Headers();
    let key = process.env.REACT_APP_API_KEY || '';
    myHeaders.append("Authorization", key);
    const petugas_cache = await getCache("current_user");

    const formdata = new FormData();
    formdata.append("petugas", petugas_cache.username);
    formdata.append("lpp_data", JSON.stringify(data));
    formdata.append("tanggal", formatted);

    const url = process.env.REACT_APP_API_URL + "/hublang/lpp";
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: myHeaders,
            body: formdata,
            redirect: 'follow'
        })

        const result = await response.json();
        return { status: result.status, data: result.data }
    } catch (error) {
        console.error('Error :',error);
        return { status: 500, message: "Terjadi kesalahan pada server", data: [] };
    }
}

export const fetchGetDataRekairPeriode = async (periode : string) => {
    return { status : 500, message : "Nothing", data : [] };
}

export const fetchPathDataRekairKoreksi = async (data : any) => {
    let key = process.env.REACT_APP_API_KEY || '';
    var myHeaders = new Headers();
    myHeaders.append("Authorization", key);

    const url = process.env.REACT_APP_API_URL + "/sapto/rekair/koreksi";

    const formdata = new FormData();
    formdata.append("nsb", data.nsb);
    formdata.append("noblth", data.noblth);
    formdata.append("mlalu", data.mlalu);
    formdata.append("mkini", data.mkini);
    formdata.append("pakai", data.pakai);
    formdata.append("hair", data.hair);
    formdata.append("adm", data.adm);
    formdata.append("R1", data.R1);
    formdata.append("R2", data.R2);
    formdata.append("R3", data.R3);
    formdata.append("T1", data.T1);
    formdata.append("T2", data.T2);
    formdata.append("T3", data.T3);
    formdata.append("T4", data.T4);
    formdata.append("B1", data.B1);
    formdata.append("B2", data.B2);
    formdata.append("B3", data.B3);
    formdata.append("B4", data.B4);

    formdata.append("denda", data.denda);

    const requestOptions = {
        method: "PATCH",
        headers: myHeaders,
        body: formdata,
        redirect: "follow" as RequestRedirect,
    };

    try {
        const response = await fetch(url, requestOptions)        
        const result = await response.json();
        return { status: result.status, data: result.data };
    }
    catch (error) {
        console.error("Error:", error);
        return { status: 500, message: "Terjadi kesalahan pada server", data: [] };
    }    
}